export default class HouseAdFormat {}
HouseAdFormat.FullStrip = 'full-strip';
